import { render, staticRenderFns } from "./TableListTaxesCompleted.vue?vue&type=template&id=2749772d&"
import script from "./TableListTaxesCompleted.vue?vue&type=script&lang=js&"
export * from "./TableListTaxesCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports